window.TTBilling = {

	createDoc : function(){

		var options = {
			title	: Loc.g("Refacturation des heures"),
			width:900,
			buttons	: [
				{text : Loc.g("Créer le document en insérant les heures"), click : function(){
						TTBilling.prepareCreateForm(false);
						$('#createTimeBillingDoc').submit();
					}},
				{text : Loc.g("Générer une feuille d'heures"), click : function(){TTBilling.genTimesheet('create');}}
			],
			callback	: function(){TTBilling.prepareCreateForm(true);}
		};
		MyWindow.load("ttbilling_doc", {action:"createDoc"}, options);
	},

	prepareCreateForm : function(tokenInput){
		var formId = "createTimeBillingDoc";
		var options = {
			success:function(data){TTBilling.recordCreateDocCallback(data);},
			dataType:"json"
		};
		MyForm.prepare(formId, "ttbilling_doc&action=recordCreateDoc", options, true);
		if(tokenInput){
			TokenInput.autoContactListing($('#ttb_thirdid'), 'third', 1, true, {}, 'TTBilling.loadTimetrackingEntries(item)');
		}
		MyFacture.initEvent();

	},

	recordCreateDocCallback : function(data){

		var formIsOk = MyForm.processJson(data, "createTimeBillingDoc");
		if(formIsOk){
			var formPost = '<form id="actionForm" action="/?_f=ttbilling_doc" method="POST">'
							+'<input type="hidden" name="action" value="initDocForm" />'
							+'<input type="hidden" name="hash" value="'+data.hash+'" />'
							+'</form>';
			$("#createTimeBillingDoc").after(formPost);
			$('#actionForm').submit();
			//Utils.relocate('./?_f=ttbilling_doc&action=initDocForm&hash='+data.hash);
		}else{
			if(data.form.msg != ''){
				MyWindow.alert(data.form.msg, {type: 'error'});
			}
		}

	},

	loadTimetrackingEntries : function(item){

		MyFacture.post('ttbilling_doc', {action:"retrieveTimetrackingEntries", third : item.id}, function(data){
			$('#entriesListing').html(data.entries);
			Qtip.init();
		}, 'json');

	},

	fillDoc : function(docid){

		var options = {
			dialogClass : "white",
			title	: Loc.g("Refacturation des heures"),
			width: MyWindow.medium,
			buttons	: [
				{text : Loc.g("Insérer les heures"), click : function(){TTBilling.prepareFillDocForm();$('#fillDocForm').submit()}},
				{text : Loc.g("Générer une feuille d'heures"), click : function(){TTBilling.genTimesheet();}}
			],
			callback	: function(){TTBilling.prepareFillDocForm();}
		};
		MyWindow.load("ttbilling_doc", {action:"fillDocForm", docid:docid}, options);

	},

	prepareFillDocForm : function(){

		var formId = "fillDocForm";
		var options = {
			success:function(data){TTBilling.recordfillDocCallback(data);},
			dataType:"json"
		};
		MyForm.prepare(formId, "ttbilling_doc&action=addToDoc", options, true);
		Qtip.init();
	},


	genTimesheet : function(from){
		if(from === 'create'){
			var formId = "createTimeBillingDoc";
			var action = "genTimesheetDocTypeThird";
		} else{
			var formId = "fillDocForm";
			var action = "genTimesheet";
		}
		var options = {
			success:function(data){
				TTBilling.downloadTimesheet(data,formId);
			},
			dataType:"json"
		};
		MyForm.prepare(formId, "ttbilling_doc&action="+action, options, true);
		MyFacture.customForm();
		$("#"+formId).submit();

	},

	downloadTimesheet : function(data, formId){

		var formIsOk = MyForm.processJson(data, "fillDocForm");
		if(formIsOk) {
			var formPost = '<form id="actionForm" action="/?_f=ttbilling_doc" method="POST">'
							+'<input type="hidden" name="action" value="downloadTimesheet" />'
							+'<input type="hidden" name="hash" value="'+data.hash+'" />'
							+'</form>';
			$("#"+formId).after(formPost);
			$('#actionForm').submit();
		}else{
			if(data.form.msg != ''){
				MyWindow.alert(data.form.msg, {type: 'error'});
			}
		}

	},

	recordfillDocCallback : function(data){

		var formIsOk = MyForm.processJson(data, "fillDocForm");
		if(formIsOk){
			Utils.reload();
		}else{
			if(data.form.msg != ''){
				MyWindow.alert(data.form.msg, {type: 'error'});

			}
		}

	},

	checkHourBilled : function(){
		var displayButton = true;
		$('#tableHourBilled input[type="checkbox"]').each(function(){
			var entrychecked = $(this).is(':checked');
			if(entrychecked){
				displayButton = false;
			}
		});

		if(displayButton){
			//afficher le bouton
			$('.ui-dialog-buttonpane').find('.ui-dialog-buttonset .ui-button').first().css('display','inline');
			$('#infoHourBilled').css('display','none');
		}
		else{
			$('.ui-dialog-buttonpane').find('.ui-dialog-buttonset .ui-button').first().css('display','none');
			$('#infoHourBilled').css('display','block');
		}
	},

    toggleAllRows: function(){
		var checker = $('#ttbilling_checkerAllRows').prop('checked');

		if(checker){
			$('#entriesListing tbody input[type=checkbox]').prop('checked',true);
		} else{
            $('#entriesListing tbody input[type=checkbox]').prop('checked',false);
		}
	}

};
